module.exports = __webpack_public_path__ + "img/aromatherapy-for-the-courageous.1fda5d5d.png";